/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ViewCaseCloserRequest/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconSend from 'DesignSystem/Svgs/TysiaIconSend/index'



/** @type {import('Simple/types.js').View} */
export default function ViewCaseCloserRequest({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus/Content/Content/Icon/ViewCaseCloserRequest"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaIconSend
  viewPath={`${viewPath}/TysiaIconSend`}
 fill="#724BB7"
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 width={20}
 height={20}
/>
{children}
</React.Fragment>)
}